import { render } from "./anc_present_pregnancy.vue?vue&type=template&id=2b86f149&scoped=true"
import script from "./anc_present_pregnancy.vue?vue&type=script&lang=js"
export * from "./anc_present_pregnancy.vue?vue&type=script&lang=js"

import "./anc_present_pregnancy.vue?vue&type=style&index=0&id=2b86f149&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b86f149"]])

export default __exports__